import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface RelatorioFinanciadorRow {
  contrato_id: string;
  contrato_nome: string;
  contratada: string | null;
  valor_global: number | null;
  data_inicio: string | null;
  data_fim_prevista: string | null;
  contrato_status: string | null;
  prob_on_time: number | null;
  p10_data: string | null;
  p50_data: string | null;
  p80_data: string | null;
  p90_data: string | null;
  p10_dias: number | null;
  p50_dias: number | null;
  p80_dias: number | null;
  p90_dias: number | null;
  mc_media_dias: number | null;
  mc_desvio_dias: number | null;
  mc_iteracoes: number | null;
  drivers_risco: Array<{ fator: string; impacto: string; severidade: string }> | null;
  mc_benchmark_usado: boolean | null;
  mc_data_calculo: string | null;
  spi: number | null;
  cpi: number | null;
  eac: number | null;
  bac: number | null;
  earned_value: number | null;
  actual_cost: number | null;
  trend_spi: string | null;
  forecast_termino: string | null;
  progresso_fisico_pct: number | null;
  alertas_ativos_count: number | null;
  alertas_criticos_count: number | null;
}

export function useEmpRelatorioFinanciador(contratoId: string | null) {
  return useQuery({
    queryKey: ['emp-relatorio-financiador', contratoId],
    queryFn: async (): Promise<RelatorioFinanciadorRow | null> => {
      if (!contratoId) return null;
      const { data, error } = await (supabase as any)
        .from('emp_vw_relatorio_financiador')
        .select('*')
        .eq('contrato_id', contratoId)
        .maybeSingle();
      if (error) { console.error('[REL-FIN]', error.message); return null; }
      return data as RelatorioFinanciadorRow | null;
    },
    enabled: !!contratoId,
    staleTime: 3 * 60 * 1000,
  });
}

export function useEmpRelatorioFinanciadorAll() {
  return useQuery({
    queryKey: ['emp-relatorio-financiador-all'],
    queryFn: async (): Promise<RelatorioFinanciadorRow[]> => {
      const { data, error } = await (supabase as any)
        .from('emp_vw_relatorio_financiador')
        .select('*')
        .order('contrato_nome');
      if (error) { console.error('[REL-FIN]', error.message); return []; }
      return (data ?? []) as RelatorioFinanciadorRow[];
    },
    staleTime: 3 * 60 * 1000,
  });
}
